export type HomeRenovationFaqEntry = {
  id: string
  question: string
  answer: string
}

export const homeRenovationFaq: HomeRenovationFaqEntry[] = [
  {
    id: 'home-renovation-faq-0',
    question: 'Como conseguir dinheiro para reformar a casa?',
    answer:
      'Uma alternativa é contratar um Crédito com Garantia de Imóvel. Nessa modalidade, um imóvel elegível é oferecido como garantia e o recurso liberado pode ser usado livremente na reforma, da compra de materiais ao pagamento da mão de obra.'
  },
  {
    id: 'home-renovation-faq-1',
    question: 'Qual o melhor tipo de crédito para reforma residencial?',
    answer:
      'A escolha depende do valor da obra, do prazo e da sua capacidade de pagamento. Para reformas maiores, o Crédito com Garantia de Imóvel pode oferecer taxas mais baixas, prazo de até 240 meses e liberdade para usar o recurso nas diferentes etapas do projeto.'
  },
  {
    id: 'home-renovation-faq-2',
    question: 'Vale a pena fazer empréstimo para reformar a casa?',
    answer:
      'Pode valer a pena quando a reforma é importante para o conforto, a segurança ou a valorização do imóvel e as parcelas cabem no orçamento. Antes da contratação, avalie o custo total da operação e mantenha uma reserva para imprevistos da obra.'
  },
  {
    id: 'home-renovation-faq-3',
    question: 'Posso usar o crédito para comprar materiais de construção?',
    answer:
      'Sim. O recurso do Crédito com Garantia de Imóvel é de uso livre e pode ser utilizado na compra de materiais de construção, acabamentos e outros itens necessários para a reforma.'
  },
  {
    id: 'home-renovation-faq-4',
    question: 'Posso usar o crédito para contratar mão de obra?',
    answer:
      'Sim. Você pode usar o crédito para contratar profissionais, pagar fornecedores e custear a mão de obra necessária para executar a reforma.'
  },
  {
    id: 'home-renovation-faq-5',
    question: 'Posso usar o crédito para decoração?',
    answer:
      'Sim. Como o recurso é de uso livre, ele também pode ser direcionado para decoração, iluminação, acabamentos e projetos de interiores.'
  },
  {
    id: 'home-renovation-faq-6',
    question: 'Posso usar o crédito para comprar móveis planejados?',
    answer:
      'Sim. Móveis planejados, marcenaria e outros itens que façam parte da transformação dos ambientes podem ser pagos com o valor liberado.'
  },
  {
    id: 'home-renovation-faq-7',
    question: 'Posso usar o crédito para reforma de apartamento?',
    answer:
      'Sim. O crédito pode ser usado para reformar casas ou apartamentos. A contratação e o imóvel oferecido como garantia passam pelas análises financeira, jurídica e de avaliação da CashMe.'
  },
  {
    id: 'home-renovation-faq-8',
    question: 'Posso usar o crédito para ampliar minha casa?',
    answer:
      'Sim. O recurso pode ser utilizado para ampliar ambientes, construir novos espaços ou modernizar áreas existentes, respeitando as autorizações e regras aplicáveis à obra.'
  },
  {
    id: 'home-renovation-faq-9',
    question: 'O que é Crédito com Garantia de Imóvel?',
    answer:
      'Também conhecido como Home Equity, é uma linha de crédito em que um imóvel é usado como garantia da operação. Na CashMe, é possível acessar até 60% do valor avaliado do imóvel, com prazo de até 240 meses e uso livre do recurso.'
  },
  {
    id: 'home-renovation-faq-10',
    question: 'Como funciona o Crédito com Garantia de Imóvel?',
    answer:
      'Você faz uma simulação, envia as informações para análise e o imóvel passa por avaliação jurídica e de valor. Depois da aprovação e da assinatura do contrato, a garantia é registrada e o dinheiro é liberado na conta indicada.'
  },
  {
    id: 'home-renovation-faq-11',
    question: 'Posso continuar morando no imóvel?',
    answer:
      'Sim. Você continua com a posse e pode morar ou usar o imóvel normalmente durante o contrato, desde que mantenha as obrigações da operação em dia.'
  },
  {
    id: 'home-renovation-faq-12',
    question: 'Qual o valor mínimo de crédito?',
    answer:
      'Na CashMe, o Crédito com Garantia de Imóvel está disponível a partir de R$ 50 mil. O valor aprovado depende da análise do perfil, da documentação e da avaliação do imóvel oferecido como garantia.'
  },
  {
    id: 'home-renovation-faq-13',
    question: 'Quanto tempo demora a aprovação?',
    answer:
      'O prazo varia conforme a análise de crédito, a avaliação do imóvel e a entrega da documentação necessária. A CashMe acompanha cada etapa para tornar o processo mais simples e seguro.'
  },
  {
    id: 'home-renovation-faq-14',
    question: 'Quem pode solicitar o crédito?',
    answer:
      'Pessoas físicas ou jurídicas podem solicitar a análise, inclusive com composição de renda. A aprovação está sujeita à avaliação do perfil financeiro, dos participantes e do imóvel oferecido como garantia.'
  },
  {
    id: 'home-renovation-faq-15',
    question: 'Quais imóveis podem ser usados como garantia?',
    answer:
      'A CashMe analisa imóveis residenciais, como casas e apartamentos, imóveis comerciais e terrenos urbanos ou dentro de condomínios. O bem pode ser novo ou usado e precisa atender aos critérios jurídicos e de avaliação da operação.'
  }
]

export const homeRenovationFaqAccordion = homeRenovationFaq.map(({ id, question, answer }) => ({
  id,
  title: question,
  item: [
    {
      id: `${id}-answer`,
      type: 'text' as const,
      content: answer
    }
  ]
}))
